import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@/components/ui/theme-provider";
import { BrandVariantProvider } from "@/design-system/components/BrandVariantProvider";
import { PublicCookieConsentBanner } from "@/components/gdpr/PublicCookieConsentBanner";
import { publicRouter } from "./public-router";
import { AnalyticsBootstrap } from "@/components/analytics/AnalyticsBootstrap";

export default function PublicApp() {
  return (
    <BrandVariantProvider defaultVariant="base">
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme" attribute="class">
        <AnalyticsBootstrap />
        <PublicCookieConsentBanner />
        <RouterProvider router={publicRouter} />
      </ThemeProvider>
    </BrandVariantProvider>
  );
}
